import FinderViewBase from '../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WeekplanReport.html?raw';
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";
class WeekplanReport extends compose(FinderViewBase) {
    templateString: any = template;

    resultActionbar: HTMLElement;
    buttonClickTimeout: number = null;

    // damit man das name und containerNode im Bedarfsfall nur an einer Stelle ändern muss
    filesTableParams: tableParams = { widgetName: "filesTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "entitylist";
    loadFilterDatatUrl = "WeekplanReport/GetFileList";
    loadFinderConfigUrl = "WeekplanReport/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["FileFinder_BtnSubmitNext"];
    btnSubmitLabelText = "Report generieren";

    protected _tableLayouts: any = [{
        "name": "default",
        "label": "Default",
        "rows": [{
            "attributes": [
                "description",
                "filelink_1"
            ],
            "colspans": [
                1,
                1,
                1,
            ],
            "headings": [
                "Bezeichnung",
                "Pfad",
                "Download"
            ],
            "colNamesInternal": [
                "Bezeichnung",
                "Pfad",
                "Download"
            ]

        }
        ],

    }];

    filesTtable_formatterFunction(cell: StaticTable.StaticTableCell<any>) {
        let name = cell.name;
        let node = cell.tableCellNode;
        let value = cell.value;
        let header = cell.name;

        switch (header) {
            case "Download":
                var btn = new Button();
                btn.setLabel("Download");
                //btn._onClick_Button = lang.hitch(this, "_onClick_Download", entity, rowIndex); 
                btn.placeAt(node);
                return true;
                break;
            default:
                return false;
        }
    }

    // -------------------------------------- METHODS -----------------------------------------------
    // overrides -----------------------------------------------start
    _onClick_Submit(evt: Event) {
        var data = JSON.parse(this._currentFilterSettings);

        if (data) {
            data.limit = this._maxResultCount;
            data.currentStartIndex = this._getOffsetFromPage(this._currentPage);
        }

        var stringData = JSON.stringify(data);

        location.href = window.appRoot + "WeekplanReport/Download?jsonData=" + stringData;
        //if (this._isRequestActive === true || (this.isDirty != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
        //    return;
        //}
        //this.getFilterlist();
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.filesTableParams) {

            // z.B. gleich eine Tabelle kreieren
            this.createTable(this.filesTableParams.widgetName, this[this.filesTableParams.sContainerNodeName], "default", this._completeList, lang.hitch( this, this.filesTtable_formatterFunction ));
        } 
    }
    // --------------overrides ------------------------------------end
    // --------------------own methods ----------------------------start


    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(WeekplanReport);